'use client';

import { clsx } from 'clsx';

import { CardProps } from '@monoimin/sb-types';
import { CardsCollection } from '@monoimin/molecules/cards/CardsCollection';
import { Typography } from '@monoimin/atoms';

import { useLocale } from '@monoimin/intl';
import { OptionalSection } from '@monoimin/ui-core';

const titles = {
  en: 'Articles and news',
  ru: 'Статьи и новости',
  de: 'Artikelen en nieuws',
};
const description = {
  en: 'We follow changes in the industry, analyse the market, and answer frequently asked questions.',
  ru: 'Мы следим за изменениями в отрасли, анализируем рынок и отвечаем на часто задаваемые вопросы.',
  de: 'Wij volgen veranderingen in de sector, analyseren de markt en beantwoorden veelgestelde vragen.',
};

export function NotFoundArticles({ cards }: { cards?: CardProps[] }) {
  const locale = useLocale();
  const title = titles[locale as keyof typeof titles];
  const desc = description[locale as keyof typeof description];

  if (!cards?.length) {
    return null;
  }
  return (
    <OptionalSection
      heading={title}
      className='max-lg:max-w-[750px]'
      dataTestId='not-found-articles'
    >
      {title && (
        <div className='flex justify-between mb-3 md:mb-7'>
          <Typography as='h2' className='w-8/12 max-lg:w-full'>
            {title}
          </Typography>
        </div>
      )}
      {desc && (
        <Typography className='subheading w-8/12 max-lg:w-full'>
          {desc}
        </Typography>
      )}
      <CardsCollection
        classNames={{
          container: clsx({
            'mt-9 md:mt-12': desc,
          }),
        }}
        items={cards}
      />
    </OptionalSection>
  );
}
